import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { RouteComponentProps } from "react-router";
import {
  ActionsBar,
  HeadBar,
} from "../../../components/Reports/Utilities/components";
import {
  StyledBackgroundRow,
  StyledWrap,
} from "../../../components/Reports/Reports.styles";
import * as Sidebar from "../../../components/Reports/SideBar.styles";
import { UtilitiesPortfolio } from "../../../components/Reports/Utilities";
import { TimeFrame } from "../../../context/reports/utilities/types";
import { UTILITIES_PERSIST_KEY } from "../../../context/reports/utilities/constants";
import { getMetricsTypeFromUrl } from "./utils";
import { useUtilities } from "../../../context/reports/utilities";
import { useActions } from "../../../context/reports/utilities/useActions";
import { useUtilitiesEffect } from "./hooks/useUtilitiesEffect";
import { updateIsMultiSiteRoute } from "../../../redux/modules/_BETA/selections";

const mapStateToProps = (state: Insite.AppState) => ({
  selectedSites: state.betaSelections.selectedSites,
  appReady: state.appSetup.appSetupComplete,
});

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    setMultiSite: () => dispatch(updateIsMultiSiteRoute(true)),
  };
}

type ConnectedProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type Props = ConnectedProps &
  DispatchProps &
  RouteComponentProps<{ type: string }>;

const Scene: React.FunctionComponent<Props> = ({
  appReady,
  selectedSites,
  match,
  setMultiSite,
}) => {
  const [state] = useUtilities();
  const { setTimeFrame } = useActions();
  const metricsType = getMetricsTypeFromUrl(match);

  React.useEffect(() => {
    if (selectedSites.length > 1) {
      setMultiSite();
    }
  }, []);

  useUtilitiesEffect(metricsType, selectedSites);

  const handleTimeFrameChange = React.useCallback(
    function handleTimeFrameChange(
      timeFrameOption: TimeFrame,
      startDate: string,
      endDate: string
    ) {
      setTimeFrame(timeFrameOption, startDate, endDate);
    },
    []
  );

  if (!appReady) return null;

  return (
    <>
      <Helmet title="Performance - Utilities" />
      <StyledBackgroundRow>
        <HeadBar
          subTitle="Utilities Performance"
          defaultTimeFrame={state.timeFrameOption}
          onTimeFrameChange={handleTimeFrameChange}
          persistKey={UTILITIES_PERSIST_KEY}
        />
      </StyledBackgroundRow>
      <StyledWrap>
        <Sidebar.Container>
          <Sidebar.Section>
            <Sidebar.Heading>Reports</Sidebar.Heading>
            <ActionsBar active={metricsType} />
          </Sidebar.Section>
        </Sidebar.Container>
        <UtilitiesPortfolio />
      </StyledWrap>
    </>
  );
};

export const PortfolioScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(Scene);
